import cn from "classnames";

import i from "@styles/icons.module.scss";
import Loading from "@ui-kit/Loading/Loading";

import s from "./SearchInput.module.scss";

const SearchInput = ({
  icon,
  label,
  className,
  type = "text",
  size = "l",
  value = "",
  placeholder = "",
  onFocus = () => {},
  loading,
  onClearButton = () => {},
  hasClearButton = false,
  inputRef,
  ...props
}) => {
  const classes = cn(
    s.searchInput,
    className,
    s[size],
    icon && s.withIcon,
    value && s.hasValue,
    placeholder && s.withPlaceholder,
    // inputValue && s.hasValue
  );

  const handleClearButton = (e) => {
    e.stopPropagation();
    onClearButton();
  };

  return (
    <div className={classes} data-title={props["data-title"]}>
      <input
        {...props}
        value={loading ? "" : value}
        type={type}
        placeholder={loading ? "" : placeholder}
        onFocus={onFocus}
        ref={inputRef}
      />
      {loading && <Loading className={s.loading} size={7} />}
      {label && <label>{label}</label>}
      {icon && <icon className={cn(s.icon, i[icon])} />}
      {hasClearButton && value && (
        <div className={s.clearButton} onClick={handleClearButton}>
          <icon className={i.close} />
        </div>
      )}
    </div>
  );
};

export default SearchInput;
